<template>
    <v-card v-if="user">
        <v-card-title>
            Editing User:
            {{ user.firstName }} {{ user.lastName }}
            {{ user.displayName ? `(` + user.displayName + `)` : '' }}
            <v-spacer></v-spacer>
            <v-btn color="error" @click="toggleDisable">{{ user.isAccountDisabled ? 'Enable' : 'Disable' }}</v-btn>
        </v-card-title>
        <v-container fluid>
            <div class="text-h6 pb-3">Teams</div>
            <v-row>
                <v-col cols="12" md="4">
                    <v-select
                        v-model="defaultTeamId"
                        :items="teams"
                        label="Default Team"
                        item-text="name"
                        item-value="id"
                        outlined
                        dense
                        :readonly="readOnly"
                    ></v-select>
                </v-col>
                <v-col cols="12" md="8">
                    <v-autocomplete
                        v-model="otherTeams"
                        :items="filteredOtherTeams"
                        label="Other teams..."
                        item-text="name"
                        item-value="id"
                        multiple
                        chips
                        outlined
                        dense
                        :readonly="readOnly"
                    ></v-autocomplete>
                </v-col>
            </v-row>
            <div class="text-h6 pb-3">Role</div>
            <v-row>
                <v-col cols="12" md="6">
                    <v-autocomplete
                        v-model="user.roles"
                        :items="roles"
                        label="Roles"
                        item-text="name"
                        item-value="name"
                        multiple
                        chips
                        outlined
                        dense
                        :readonly="readOnly"
                    ></v-autocomplete>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="12" md="4">
                    <div class="d-flex justify-center justify-md-end">
                        <v-btn @click="saveChanges">Save Changes</v-btn>
                    </div>
                </v-col>
            </v-row>
        </v-container>
    </v-card>
</template>
<script>
import api from '@/api'
import navGuardConfirmMixin from '../../mixins/navGuardConfirmMixin'
export default {
    name: 'UserEditor',
    mixins: [navGuardConfirmMixin],
    data() {
        return {
            isLoading: false,
            isSaving: false,
            user: null,
            defaultTeamId: 0,
            otherTeams: [],
            teams: [],
            roles: [],
        }
    },
    props: {
        id: {
            type: [String],
            required: true,
        },
    },
    computed: {
        readOnly() {
            return this.user ? this.user.isAccountDisabled : true
        },
        filteredOtherTeams() {
            return this.teams.filter(x => x.id !== this.defaultTeamId)
        },
    },
    watch: {
        defaultTeamId() {
            this.isDirty = true
        },
        otherTeams() {
            this.isDirty = true
        },
    },
    mounted() {
        this.getTeams()
        this.getRoles()
        this.getUser()
    },
    methods: {
        getUser() {
            this.isLoading = true
            api.get(`user/GetUserById/${this.id}`)
                .then(res => {
                    this.user = res
                    let defaultTeam = this.user.teams.find(x => x.isDefault)
                    this.defaultTeamId = defaultTeam ? defaultTeam.teamId : 0
                    this.otherTeams = this.user.teams.filter(x => x !== this.defaultTeamId).map(x => x.teamId)
                })
                .finally(() => {
                    this.isDirty = false
                    this.isLoading = false
                })
        },
        getTeams() {
            this.isLoading = true
            api.getTeams()
                .then(res => {
                    this.teams = res
                })
                .finally(() => {
                    this.isLoading = false
                })
        },
        getRoles() {
            this.isLoading = true
            api.get('role/getAll')
                .then(res => {
                    this.roles = res
                })
                .finally(() => {
                    this.isLoading = false
                })
        },
        getDefaultTeamId() {
            if (!this.user || !this.user.teams || this.user.teams.length === 0) return 0
            let defaultTeam = this.user.teams.find(x => x.isDefault)
            if (!defaultTeam) return 0
            return defaultTeam.teamId
        },
        saveChanges() {
            this.isSaving = true
            let newTeams = this.otherTeams.map(x => {
                return {
                    teamId: x,
                    isDefault: false,
                }
            })
            let existing = newTeams.find(x => x.teamId === this.defaultTeamId)
            if (existing) {
                existing.isDefault = true
            } else {
                newTeams.push({ teamId: this.defaultTeamId, isDefault: true })
            }
            let data = {
                teams: newTeams,
                roles: this.user.roles,
            }
            api.post(`user/updateUser/${this.id}`, data)
                .then(() => {
                    this.showSnackbar('info', 'User Updated')
                    this.isDirty = false
                    this.$router.push({ name: 'users' })
                })
                .finally(() => {
                    this.isSaving = false
                })
        },
        toggleDisable() {
            this.isSaving = true
            if (this.user.isAccountDisabled) {
                api.post(`user/enableUser/${this.id}`)
                    .then(() => {
                        this.user.isAccountDisabled = false
                    })
                    .finally(() => {
                        this.isSaving = false
                    })
            } else {
                api.post(`user/disableUser/${this.id}`)
                    .then(() => {
                        this.user.isAccountDisabled = true
                    })
                    .finally(() => {
                        this.isSaving = false
                    })
            }
        },
    },
}
</script>
